import { Button, Popconfirm, Space, Typography } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import useHasPermissions from "hooks/useHasPermissions";
import Header from "components/layout/Header";

import VenueForm from "../VenueForm";

import { useVenueDetails } from "./hooks";

const VenueDetails = () => {
  const intl = useIntl();
  const { onDelete, ...form } = useVenueDetails();
  const canDeleteVenue = useHasPermissions([Permission.VENUE_DELETE]);

  return (
    <>
      <Header loading={form.loading}>
        <Typography.Title>
          <FormattedMessage
            defaultMessage="{name} details"
            values={{ name: form.initialValues?.input?.name }}
          />
        </Typography.Title>
      </Header>
      <Space />
      <VenueForm $isReadOnly {...form}>
        {canDeleteVenue && (
          <Popconfirm
            title={intl.formatMessage({
              defaultMessage: "Are you sure?",
            })}
            onConfirm={onDelete}
          >
            <Button
              type="primary"
              danger
              htmlType="submit"
              loading={form.loading}
            >
              <FormattedMessage defaultMessage="Delete Venue" />
            </Button>
          </Popconfirm>
        )}
      </VenueForm>
    </>
  );
};

export default VenueDetails;
